// src/components/subcription/SubscriptionPlanSkeleton.jsx

import styles from "../../styles/SubscriptionPlans.module.css";
import Skeleton from "../../ui/Skeleton";

const SubscriptionPlanCardSkeleton = () => {
  return (
    <article className={styles.card}>
      <div className={styles.cardTop}>
        <div>
          <div className={styles.cardHeadingRow}>
            <Skeleton
              style={{
                width: "55%",
                height: 24,
                borderRadius: 8,
              }}
            />

            <Skeleton
              style={{
                width: 70,
                height: 26,
                borderRadius: 999,
              }}
            />
          </div>

          <Skeleton
            style={{
              marginTop: 12,
              width: "100%",
              height: 14,
            }}
          />

          <Skeleton
            style={{
              marginTop: 8,
              width: "80%",
              height: 14,
            }}
          />
        </div>

        <div className={styles.priceWrap}>
          <Skeleton
            style={{
              width: "70%",
              height: 38,
            }}
          />

          <Skeleton
            style={{
              marginTop: 8,
              width: "50%",
              height: 14,
            }}
          />
        </div>
      </div>

      <div className={styles.quotaBox}>
        {[1, 2, 3].map((item) => (
          <div
            key={item}
            className={styles.quotaItem}
          >
            <Skeleton
              style={{
                width: "40%",
                height: 14,
              }}
            />

            <Skeleton
              style={{
                width: "30%",
                height: 14,
              }}
            />
          </div>
        ))}
      </div>

      <div className={styles.featureList}>
        {Array.from({ length: 6 }).map((_, index) => (
          <div
            key={index}
            className={styles.featureItem}
          >
            <Skeleton
              style={{
                width: 18,
                height: 18,
                borderRadius: "50%",
              }}
            />

            <Skeleton
              style={{
                width: `${95 - index * 10}%`,
                height: 14,
              }}
            />
          </div>
        ))}
      </div>

      <div className={styles.cardFooter}>
        <Skeleton
          style={{
            width: "100%",
            height: 50,
            borderRadius: 16,
          }}
        />
      </div>
    </article>
  );
};

const SubscriptionPlansSkeleton = () => {
  return (
    <div className={styles.grid}>
      {Array.from({ length: 4 }).map((_, index) => (
        <SubscriptionPlanCardSkeleton key={index} />
      ))}
    </div>
  );
};

export default SubscriptionPlansSkeleton;
